import { createActions } from 'redux-actions';
import types from './types';

const {
  setModules,
  clearModules,
  setCustomLinks,
  setYoutube,
  setVimeo,
  setPagesLinks,
  clearCustomLinks,
  clearYoutube,
  clearPagesLinks,
} = createActions(
  types.SET_MODULES,
  types.CLEAR_MODULES,
  types.SET_CUSTOM_LINKS,
  types.SET_YOUTUBE,
  types.SET_VIMEO,
  types.SET_PAGES_LINKS,
  types.CLEAR_CUSTOM_LINKS,
  types.CLEAR_YOUTUBE,
  types.CLEAR_PAGES_LINKS,
);

export default { setModules,
  clearModules,
  setCustomLinks,
  setYoutube,
  setVimeo,
  setPagesLinks,
  clearCustomLinks,
  clearYoutube,
  clearPagesLinks };



// WEBPACK FOOTER //
// ./src/reducers/modules/actions.js